export const AllowedFakeDataHostnames = new Set(['localhost', 'quicksourcevuedev.alamode.com']);

export function isFakeDataHostnameAllowed(hostname: string): boolean {
    return AllowedFakeDataHostnames.has(String(hostname || '').toLowerCase());
}
